import { Button, Stack } from "@altimateai/lego";

interface Props {
  options: readonly string[];
  selected: string | null;
  onSelect: (value: string | null) => void;
  totalLabel?: string;
}

const DatabricksCostCategorySelector = ({
  options,
  selected,
  onSelect,
  totalLabel = "Total",
}: Props) => (
  <Stack className="al-bg-blue-100 al-rounded-md !al-flex-wrap" gap="none">
    <Button variant={selected === null ? "default" : "ghost"} onClick={() => onSelect(null)}>
      {totalLabel}
    </Button>
    {options.map(option => (
      <Button
        key={option}
        variant={selected === option ? "default" : "ghost"}
        onClick={() => onSelect(option)}
      >
        {option}
      </Button>
    ))}
  </Stack>
);

export default DatabricksCostCategorySelector;
